import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { TypeEntreprise } from 'src/app/shared/models/typeEntreprise';

@Component({
	selector: 'app-typeEntreprise-modal-ajout',
	templateUrl: './typeEntreprise-modal-ajout.component.html',
	styleUrls: ['./typeEntreprise-modal-ajout.component.scss']
})
export class TypeEntrepriseModalAjoutComponent {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required
		])
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService
	) {}

	// ngOnInit(): void {}

	onSubmit() {
		this.isValidateButtonClicked = true;
		const typeEntreprise = new TypeEntreprise();
		typeEntreprise.name = this.formEdit.get('name').value;
		this.facade.typeEntrepriseService.addTypeEntreprise(typeEntreprise).subscribe({
			next: (succ) => {
				this.bsModalRef.hide();
				// this.isValidateButtonClicked=false;
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.logger.error(err);
			}
		});
	}

	get name() {
		return this.formEdit.get('name');
	}
}
